import Vue from "vue";

class EventBus extends Vue{
    publish(eventName: string, ...args:any[]): void {
        this.$emit(eventName, args);
    }

    subscribe(eventName: string, callback:Function, component: Vue): void {
        this.$on(eventName, callback);
        component.$once("hook:beforeDestroy", () => {
            this.$off(eventName, callback);
        })
    }
}

const bus = new EventBus();
export default bus;